<template>
  <v-sheet v-if="departments.length" class="department-selector pa-2" color="grey lighten-4">
    <div v-if="label" class="department-selector__label text-caption grey--text text--darken-2 mb-1">
      <v-icon x-small class="mr-1">mdi-office-building</v-icon>{{ label }}
    </div>
    <div
      class="department-selector__items d-flex flex-wrap align-center"
      role="group"
      :aria-label="ariaLabel"
      :style="itemsStyle"
    >
      <v-btn
        v-for="(dep, i) in departments"
        :key="dep.departmentid != null ? dep.departmentid : i"
        small
        rounded
        depressed
        text-none
        class="department-selector__item ma-1"
        :color="i === value ? 'primary' : undefined"
        :outlined="i !== value"
        :aria-pressed="i === value ? 'true' : 'false'"
        @click="$emit('input', i)"
      >
        {{ itemLabel(dep) }}
      </v-btn>
    </div>
  </v-sheet>
</template>

<script>
export default {
  name: 'DepartmentSelector',
  props: {
    value: { type: Number, default: null },
    departments: { type: Array, default: () => [] },
    showCount: Boolean,
    showDone: Boolean,
    label: { type: String, default: '' },
    ariaLabel: { type: String, default: '部门' },
    maxHeight: { type: [String, Number], default: '40vh' }
  },
  computed: {
    itemsStyle() {
      const maxHeight = typeof this.maxHeight === 'number'
        ? `${this.maxHeight}px`
        : this.maxHeight
      return {
        maxHeight: maxHeight || undefined,
        overflowY: 'auto',
        overflowX: 'hidden'
      }
    }
  },
  watch: {
    departments() {
      this.ensureValidSelection()
    },
    'departments.length'() {
      this.ensureValidSelection()
    },
    value() {
      this.ensureValidSelection()
    }
  },
  mounted() {
    this.ensureValidSelection()
  },
  methods: {
    itemLabel(dep) {
      let text = dep && dep.departmentname != null ? String(dep.departmentname) : ''
      if (this.showCount) {
        const count = dep && Array.isArray(dep.userObjectives) ? dep.userObjectives.length : 0
        text += `(${count})`
      }
      if (this.showDone) {
        text += ` ${dep && dep.done ? '✓' : '*'}`
      }
      return text
    },
    ensureValidSelection() {
      const count = this.departments.length
      if (!count) return
      if (this.value == null || this.value < 0 || this.value >= count) {
        this.$emit('input', 0)
      }
    }
  }
}
</script>

<style scoped>
.department-selector {
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
}
.department-selector__item {
  height: auto;
  min-height: 32px;
  padding: 4px 12px;
  line-height: 1.2;
  letter-spacing: 0;
  text-transform: none;
  white-space: normal;
  word-break: break-word;
  max-width: 100%;
}
</style>
